import React, { Component } from 'react'
import _ from 'underscore'
import FeedbackRating from './FeedbackRating'
import { injectIntl, FormattedMessage } from 'react-intl'

class MultipleChoiceQuestion_ extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { options, type, className, questionName, intl } = this.props
    let mainText = this.props.mainText
    if (this.props.mandatory) {
      mainText = (
        <span>
          <FormattedMessage
            id="feedbackQuestions.multipleChoice.mandatoryStar"
            defaultMessage="{mainText} {star}"
            values={{
              mainText: this.props.mainText,
              star: <span className="red-star">*</span>,
            }}
          />
        </span>
      )
    }
    let changeOption = this.props.changeOption
    let optionsDivs = Object.keys(options).map(function (value) {
      return (
        <div className="row" key={value}>
          <div className="col-sm-1 offset-sm-2">
            <input
              type={type}
              name={questionName}
              value={value}
              onChange={changeOption}
            />
          </div>
          <div className="col-sm-8">{options[value]}</div>
        </div>
      )
    })
    return (
      <div className={`${className} feedback-questions`}>
        <div className="feedback-question">{mainText}</div>
        <div className="feedback-options">{optionsDivs}</div>
      </div>
    )
  }
}

class SelectCheckBoxesQuestion_ extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { options, type, className, questionName, intl } = this.props
    let mainText = this.props.mainText
    let questionLabel = this.props.mandatory
      ? intl.formatMessage(
          {
            id: 'feedbackQuestions.selectCheckBoxes.mandatoryQuestion',
            defaultMessage: 'Mandatory question. {mainText}',
          },
          { mainText: this.props.mainText }
        )
      : this.props.mainText
    if (this.props.mandatory) {
      mainText = (
        <span>
          <FormattedMessage
            id="feedbackQuestions.multipleChoice.mandatoryStar"
            defaultMessage="{mainText} {star}"
            values={{
              mainText: this.props.mainText,
              star: <span className="red-star">*</span>,
            }}
          />
        </span>
      )
    }
    let changeOption = this.props.changeOption
    let i = 0
    let optionsDivs = Object.keys(options).map((value) => {
      i++
      return (
        <div className="col-sm-4" key={i}>
          <input
            aria-label={intl.formatMessage(
              {
                id: 'feedbackQuestions.selectCheckBoxes.ariaLabel',
                defaultMessage: 'Please check if you like {option}',
              },
              { option: options[value] }
            )}
            type={type}
            name={value}
            value={value}
            onChange={changeOption}
          />
          <span style={{ verticalAlign: '12%' }}>
            {options[value]}
          </span>
        </div>
      )
    })

    return (
      <div className={`${className} feedback-questions`}>
        <div className="feedback-question-row">
          <div className="feedback-question-count">
            {this.props.count}
          </div>
          <div
            className="feedback-question"
            tabIndex={0}
            aria-label={questionLabel}>
            {mainText}
          </div>
        </div>
        <div className="feedback-options">
          <div className="row">{optionsDivs}</div>
        </div>
      </div>
    )
  }
}

class TextQuestion_ extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { intl } = this.props
    let setFeedbackRating = this.props.setFeedbackRating
    let mainText = this.props.mainText
    let questionLabel = this.props.mandatory
      ? intl.formatMessage(
          {
            id: 'feedbackQuestions.textQuestion.mandatoryQuestion',
            defaultMessage: 'Mandatory question. {mainText}',
          },
          { mainText: this.props.mainText }
        )
      : this.props.mainText
    if (this.props.mandatory) {
      mainText = (
        <span>
          <FormattedMessage
            id="feedbackQuestions.multipleChoice.mandatoryStar"
            defaultMessage="{mainText} {star}"
            values={{
              mainText: this.props.mainText,
              star: <span className="red-star">*</span>,
            }}
          />
        </span>
      )
    }
    return (
      <div className={`${this.props.className} feedback-questions`}>
        <div className="feedback-question-row">
          <div className="feedback-question-count">
            {this.props.count}
          </div>
          <div className="feedback-question">{mainText}</div>
        </div>
        <div className="margin-5" />
        <div tabIndex="0" className="feedback-options feedback-options-textarea">
          <textarea
            aria-label={questionLabel}
            placeholder={
              _.isUndefined(this.props.placeholder)
                ? intl.formatMessage({
                    id: 'feedbackQuestions.textQuestion.placeholder',
                    defaultMessage: 'Write here',
                  })
                : this.props.placeholder
            }
            name={this.props.fieldName}
            tabIndex="0"
            maxLength={
              _.isUndefined(this.props.maxLength)
                ? '1000'
                : this.props.maxLength
            }
            onChange={this.props.textareaChange}
          />
        </div>
      </div>
    )
  }
}

class SingleRatingQuestion_ extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { intl } = this.props
    let setFeedbackRating = this.props.setFeedbackRating
    let mainText = this.props.mainText
    let questionLabel = this.props.mandatory
      ? intl.formatMessage(
          {
            id: 'feedbackQuestions.singleRating.mandatoryRating',
            defaultMessage:
              '{mainText} Mandatory rating question. 1 being the lowest, 5 being the highest.',
          },
          { mainText: this.props.mainText }
        )
      : this.props.mainText
    if (this.props.mandatory) {
      mainText = (
        <span>
          <FormattedMessage
            id="feedbackQuestions.multipleChoice.mandatoryStar"
            defaultMessage="{mainText} {star}"
            values={{
              mainText: this.props.mainText,
              star: <span className="red-star">*</span>,
            }}
          />
        </span>
      )
    }
    return (
      <div className={`${this.props.className} feedback-questions`}>
        <div className="feedback-question-row">
          <div className="feedback-question-count">
            {this.props.count}
          </div>
          <div
            className="feedback-question"
            aria-label={questionLabel}
            tabIndex={0}>
            {mainText}
          </div>
        </div>
        <br />
        <div className="feedback-rating-single-row">
          <div className="scale-rating-size">
            <div className="feedback-rating-poor">
              <FormattedMessage
                id="feedbackQuestions.singleRating.poor"
                defaultMessage="Poor"
              />
            </div>
            <div className="feedback-sub-options">
              <FeedbackRating
                setFeedbackRating={setFeedbackRating}
                rating={this.props.rating}
                className={'col-sm-2 single-question-option'}
                feedback_rating={1}
                column={this.props.fieldName}
              />
            </div>
            <div className="feedback-rating-excellent">
              <FormattedMessage
                id="feedbackQuestions.singleRating.excellent"
                defaultMessage="Excellent"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

class QuestionSet_ extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { intl } = this.props
    let questions = this.props.questions
    let setFeedbackRating = this.props.setFeedbackRating
    let mainText = this.props.mainText
    let questionLabel = this.props.mandatory
      ? intl.formatMessage(
          {
            id: 'feedbackQuestions.questionSet.mandatoryQuestion',
            defaultMessage: 'Mandatory question. {mainText}',
          },
          { mainText }
        )
      : mainText
    if (this.props.mandatory) {
      mainText = (
        <span>
          <FormattedMessage
            id="feedbackQuestions.multipleChoice.mandatoryStar"
            defaultMessage="{mainText} {star}"
            values={{
              mainText: this.props.mainText,
              star: <span className="red-star">*</span>,
            }}
          />
        </span>
      )
    }
    let i = 0
    let questionsDivs = Object.keys(questions).map((value) => {
      i++
      return (
        <div className="col-sm-6 feedback-sub-question" key={i}>
          <div className="feedback-sub-rating-title">
            <div
              className="feedback-question-subquestion"
              tabIndex={0}
              aria-label={intl.formatMessage(
                {
                  id: 'feedbackQuestions.questionSet.subQuestionAriaLabel',
                  defaultMessage: '{subQuestionText}',
                },
                { subQuestionText: questions[value].text }
              )}>
              {questions[value].text}
            </div>
          </div>
          <div className="feedback-sub-rating-size">
            <div className="feedback-rating-poor">
              <FormattedMessage
                id="feedbackQuestions.questionSet.poor"
                defaultMessage="Poor"
              />
            </div>
            <div className="feedback-sub-options">
              <FeedbackRating
                setFeedbackRating={setFeedbackRating}
                rating={questions[value].value}
                className="col-sm-2 multiple-question-option"
                feedback_rating={1}
                column={value}
              />
            </div>
            <div className="feedback-rating-excellent">
              <FormattedMessage
                id="feedbackQuestions.questionSet.excellent"
                defaultMessage="Excellent"
              />
            </div>
          </div>
        </div>
      )
    })
    return (
      <div className={`${this.props.className} feedback-questions`}>
        <div className="feedback-question-row">
          <div className="feedback-question-count">
            {this.props.count}
          </div>
          <div
            className="feedback-question"
            tabIndex={0}
            aria-label={questionLabel}>
            {mainText}
          </div>
        </div>
        <div className="feedback-question-set-row row">
          {questionsDivs}
        </div>
      </div>
    )
  }
}

// Export with injectIntl for intl prop
export const MultipleChoiceQuestion = injectIntl(MultipleChoiceQuestion_)
export const SelectCheckBoxesQuestion = injectIntl(SelectCheckBoxesQuestion_)
export const TextQuestion = injectIntl(TextQuestion_)
export const SingleRatingQuestion = injectIntl(SingleRatingQuestion_)
export const QuestionSet = injectIntl(QuestionSet_)